var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',{attrs:{"label":"Question Quantity:"}},[_c('vue-slider',_vm._b({attrs:{"name":"quantity"},model:{value:(_vm.questionQuantity),callback:function ($$v) {_vm.questionQuantity=$$v},expression:"questionQuantity"}},'vue-slider',_vm.questionQuantitySlider,false))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a957076","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/Quantity.vue
// module id = null
// module chunks = 